export const announcements = [
  {
    id: 'website-live',
    category: 'Sanctuary note',
    date: 'September 2026',
    title: 'The Sanctuary has a new home',
    summary: 'The official Midnight Sanctuary website is now live, with our rooms, values and community links all in one place.',
    to: '/sanctuary',
  },
  {
    id: 'discord-door',
    category: 'Discord',
    date: 'September 2026',
    title: 'The door is open',
    summary: 'Ready to step inside? Join the Discord and find the corner of the Sanctuary that feels like yours.',
    to: '/join',
  },
]
